import { Component, ViewEncapsulation } from '@angular/core';
import { OccConfig } from '@spartacus/core';
import { ProductGridItemComponent, ProductListItemContext, ProductListItemContextSource } from '@spartacus/storefront';
import { map, Observable, of } from 'rxjs';
import { GetDocumentService } from 'src/app/customServices/get-document.service';

@Component({
  selector: 'app-category-grid-item',
  templateUrl: './category-grid-item.component.html',
  styleUrls: ['./category-grid-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    ProductListItemContextSource,
    {
      provide: ProductListItemContext,
      useExisting: ProductListItemContextSource,
    },
  ],
  standalone: false
})
export class CategoryGridItemComponent extends ProductGridItemComponent {

  productUrl$: Observable<string>;
  constructor(
    protected override productListItemContextSource: ProductListItemContextSource,
    private config: OccConfig,
    private documentService: GetDocumentService,
  ) {
    super(productListItemContextSource);
  }

  baseUrl: string = this.config?.backend?.occ?.baseUrl + '/';
  ngOnInit() {
    this.productUrl$ = this.getProductUrl(this.product);
  }

  getProductUrl(product: any): Observable<string> {
    if (product.code === 'NA-000-006-002-003-002') {
      return this.documentService.getDocumentByDocumentCode('BW8223').pipe(
        map((response: { url: string }) => response.url)
      );
    }

    return of(product.url);
  }
}
